// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3sgEQ","topBottomGutter":"Layout_topBottomGutter__2TQO2"};